import { FC } from "react";
import { observer } from "mobx-react";
import { Dialog } from "@/components-v2/Dialog";
import { VBox } from "@/components-v2/Box";
import { MRadioButtonGroup } from "@/components-v2/RadioButton";
import { useTranslation } from "@/stores/RootStoreContext";
import { ExportTransactionsModel } from "./exportTransactionsDomain";

const ExportTransactions: FC<{ model: ExportTransactionsModel }> = observer(({ model }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      title={t("transactions.export.title")}
      submitLabel={t("transactions.export")}
      onSubmit={model.handleSubmitExport}
      onCancel={model.onClose}
      isSubmitting={model.isLoading}
      maxWidth={"sm"}
    >
      <VBox>
        <p>{t("transactions.export.description")}</p>
        <div>{t("transactions.export.language")}</div>
        <MRadioButtonGroup name={"exportTransactionsLanguage"} model={model.language} horizontal />
      </VBox>
    </Dialog>
  );
});

export default ExportTransactions;
